import { ToastMessage } from "../../Components/Utils";

export const handleError = (error, fallbackMessage = "Something went wrong!") => {

    let errorMessage = error?.data?.errors?.[0]?.message ||
     error?.data?.error?.[0]?.message || error?.data?.message ||  error?.response?.data?.message || error?.message || fallbackMessage;
    
    ToastMessage({
        type: "error",
        title: "Error!",
        message: errorMessage,
    });
};